export default __webpack_public_path__ + "static/Apeswap-color-4-2ade6808073ec4ed7c3d44ff49827ef3.svg";